export default {
  bank: "Bank",
  winlose: "Win/Lose",
  balance: "Balance",
  win: "Win",
  lose: "Lose",
  tie: "Tie",
  history: "History",
  transfer_details: "Transfer Details",
  id: "ID",
  game: "Game",
  contactus: "Contact",
  join_now: "Join Now",
  manual_deposit: "Manual Deposit",

  aboutus: "About Us",
  attention: "Attention",
  amount_currency: "Amount ({currency} Min: {min} Max: {max})",
  all: "All",
  amount: "Amount",
  approved: "Approved",
  and: "and",
  atm_cash: "ATM/Cash Deposit",
  account_name: "Account Name",
  account_no: "Account No.",
  amount_min: "Minimum Amount",
  amount_max_short: "Maximum Amount",
  amount_not_min: "Amount does not reach minimum requirement",
  amount_max:"Amount exceeded maximum limit",
  add_bank: "Add Bank",
  account_id: "Account ID",
  adjustment_details: "Adjustment Details",
  after_balance: "After Balance",
  android: "Android",
  atm: "ATM",
  acc_detail: "Account Details",
  amount_receive: "Amount Received",
  active_player: "Total ACTIVE PLAYERS",
  affiliate_code: "Affiliate Code",
  admin: "Admin",
  admin_open: "If you have problem receiving OTP, kindly contact us via Live Chat",
  attachment_tips: "Please upload your transaction receipt",
  accounts: "Accounts",
  active: "Active",

  bank_accname: "Account Holder",
  bank_accno: "Account Number",
  bank_name: "Bank Name",
  bank_detail: "Bank Details",
  bet_history: "Bet History",
  bank_account: "Bank Account",
  better_luck: "Better luck next time!",
  birthday: "Birthday",
  bonus_details: "Bonus Details",
  before_balance: "Before Balance",
  bonus_value: "Bonus Value",
  bonus: "Bonus",
  bank_ewallet: "E-Wallet",
  bank_ewalletname: "E-Wallet Holder",
  bank_ewalletno: "E-Wallet Number",
  brand: {
    vision: "BRAND VISION",
    vision_desc: "A world without scams. To be the slots maker with the world's fastest jackpot withdrawal",
    purpose: "BRAND PURPOSE",
    purpose_desc: "To eliminate all scams so that everyone's jackpot dream can come true"
  },
  bankdetail_reminder: "You haven't add any E-Wallet or Bank Account yet",
  bankdetail_reminder1: "Click here to add ",

  cdm: "CDM",
  counter: "COUNTER",
  cancel: "Cancel",
  change_password: "Change Password",
  confirm_password: "Confirm Password",
  close: "Close",
  claim: "Claim",
  claim_now: "claim now",
  current_balance: "Current Balance",
  cash_deposit: "Cash Deposit",
  contact_for_bank: "Contact EpicWin Livechat",
  congratulations: "Congratulations!",
  contact_number: "Contact Number",
  claim_rewards: "Claim Rewards",
  cash_value: "Cash Value",
  customer_review: "EPIC's REVIEWS",
  claim_offer: "Claim my offer!",
  custom_description: {
    comment_placeholder: "Leave your comments here",
    review_complete_header: "Thanks for spreading Good Vibes!",
    review_complete_text: "We'll Use it to improve the product.",
  },
  count: "Count",
  click_here: "Click Here",
  change: "Change",
  coupon: "Coupon",
  category: "Category",
  choose_promo: "Choose Promotion",
  choose_nopromo: "Do not participate in any promotions",

  deposit: "Deposit",
  deposit_short: "Deposit",
  deposit_enter: "Please enter deposit amount",
  deposit_method: "Deposit Method",
  deposit_method_select: "Please select a deposit method",
  deposit_reminder: "I have read, understood and agree to all the stipulated ",
  deposit_reminder_two: " covering bonuses and/or withdrawal requirements",
  download: "Download",
  download_android: "Android Download",
  download_ios: "iOS Download",
  date: "Date",
  date_expiry:"Expiry Date",
  done: "Done",
  deposit_now: "Deposit Now",
  description: "Description",
  download_1: "Join Now & Be a part of EPIC Family",
  download_2: "Your EPIC journey starts here!",
  deposit_tnc: "Deposit - Free Jackpot Tickets",
  developer_response: "Developer Response",
  daily_update: "Daily Update",
  downloadgame: "Download Game",
  duitnow:{
    desc1: "Minimum Deposit: ",
    desc1_1: "RM30",
    desc2: "Save receipt of transfer",
    desc3: "Notify LiveChat to receive credits.",
    desc4: "Enjoy playing our games!"
  },
  deposit_min:"Min. Deposit",

  email: "Email",
  enter_bank_accname: "Please enter bank account holder name",
  enter_bank_accno: "Please enter bank account number",
  enter_ewallet_name: "Please fill in E-Wallet owner's name",
  enter_ewallet_no: "Please fill in E-Wallet number",
  eta: "ETA",
  epic_production: "EPIC Production",
  edit: "Edit",

  female: "Female",
  failed: "Failed",
  forgot_password: "Forgot Password?",
  faq: "FAQ",
  footer: {
    title: "Calling all VIPs: the high rollers and just-for-fun-guys; the feet-up-unwinders and the buzz-seekers. For anyone who seek for TRUSTEDonline casino, EpicWin is here to show you the way.",
    description: "Welcome to EpicWin, home of the trendiest online slot games in Malaysia, offering players free play, free credit claim upon signup (just register to claim free credit), bonus giveaways, and of course, access to the best Malaysia online slot games that you won't find anywhere else.",
    description1: "But wait, before you start winning big, don't forget your \"claim free credit link\", which is your entitlement as a new EpicWin player that lets you kickstart your journey at this one-of-a-kind free credit casino, home to only the best free credit slot games. Register to claim free credit for your winning journey today!",
    description2: "Register to claim free credit on EpicWin and play the best Malaysia online slot games. Practice winning with EpicWin, Malaysia's best online casino with free credit, no deposit!",
    description3: "EpicWin is the top online slot Malaysia casino offering cool perks such as game slot free credit. It's a dream come true — sign up for free, claim free credit, and start your EPIC winning journey!",
  },
  for_android: "For Android",
  for_ios: "For iOS",
  find_out: "Find Out More",
  file_choose: "Choose File",
  file_upload: "Upload File",
  file_requirement: "File size cannot exceed 1mb and must be in png, jpg or jpeg format",
  full_name: "Full Name",
  fill_stars: "Kindly give your ratings before proceed",
  full_phone: "Phone Number (手机号码, Nombor Telefon)",
  full_referral: "Referral Code (邀友代码, Kod Pengajakan)",

  gender: "Gender",
  game_play: "Game Play",
  game: "Game",
  get: "Get",
  gcash_reminder: "For first time deposits, GCash face scan is required but rest assured the following transactions will not require it and is guaranteed hassle free!",

  hi: "Hi, ",
  has_won: "Has achieved",
  has_won_rate: " Winning Rate",
  has_withdraw: "Has withdrew",
  homepage: {
    header1: "ORIGINAL NOVOMATIC SLOTS",
    desc1: "Enjoy the best slots from the market leader!",
    header2: "LEADERBOARDS",
    desc2: "Play against your friends in multiple slot-themed leaderboards and races!",
    header3: "TOP BONUSES!",
    desc3: "Enjoy loads of bonuses and promotions!",
    header4: "VIP CLUB & LOYALTY PROGRAMME",
    desc4: "Let’s roll out the red carpet! As a VIP you can enjoy a host of benefits."
  },
  hourly_update: "Hourly Update",
  hot_movie: "HOT Movies",

  ios: "iOS",
  inactive: "Inactive",

  jackpot: "Jackpot",

  leaderboard_title: "TOP 15 PLAYERS WITH THE MOST MAGIC SPINS",
  login: "Login",
  logout: "Logout",
  login_now: "Login Now",
  lucky_spin: "lucky spin to win up to IDR{value}",
  latest_transactions: "Latest Transactions",
  lucky_wheel: "Lucky Wheel",
  loyalty_points: "loyalty points",
  last_4_digits: "Last 4 Digit of Phone Number",
  last_login: "Last Login",
  lang_en: "English",
  lang_zh: "Chinese",
  lang_my: "Malay",
  luckydraw_announcement: "You Will Earn Lucky Draw Tickets Upon Successful Deposit<br>Stay Tuned For Live Lucky Draw<br>19 April 2021, 7.30pm",
  language:{
    en: 'en',
    cn: 'zh-cn',
    my: 'ms'
  },
  login_otp: "Login with OTP",
  login_pass: "Login with password",

  male: "Male",
  mobile: "Mobile",
  minigames: "Mini Games",
  method: "Method",
  min: "Min",
  min_amount: "Min Amount",
  monthly_update: "Monthly Update",
  movies: "Movies",
  movie_watch: "Watch Now",
  max: "Max",

  name: "Name",
  next: "next",
  new_password: "New Password",
  no_account_yet: "No Account Yet?",
  no_win: "You did not win anything this time around :(",
  nickname: "Nickname",
  next_update_time: "Next Update Time",
  no_bonus_found: "No bonus details found",
  no_adjustment_found: "No adjustment details found",
  no_new_gifts: "No new gifts",
  no: "No.",
  no_contact: "No contact available!",
  no_new_message: "No new message",
  newsletter: "I want to know about offers & promotion via email, text or post",

  others: "Others",
  offical_team: "Official Team",
  online: "ONLINE",
  online_banking: "Online Banking",
  online_banking_set: "Online Banking ({bank})",
  option: "Option {0}",
  optional: "Optional",
  old_password: "Old Password",
  ok: "Ok",
  current_password: "Current Password",
  operator_bank_list: "Operator Bank List",
  promotion_selected: "Promotion selected",

  pending: "Pending",
  play_now: "Play Now",
  password: "Password",
  password_signup: "Password",
  phone_number: "Phone Number",
  promotion: "Promotion",
  promotions: "Promotions",
  promotion_select: "Please Select Promotion / No Promotion",
  profile: "Profile",
  privacy_policy: "Privacy Policy",
  privacy_statement: "Privacy Statement",
  password_tips:"Password must be 6-20 characters",
  phone_tips: "Valid phone number ONLY eg: +63 9163451812, no spacing",
  problem_contact:"If you have problem receiving a code, kindly contact us via Live Chat.",
  reset_tips: "Please enter last 4 digits of your phone number",
  prev: "Prev",
  please_select: "Please Select",
  please_select_bank: "Please Select a Bank",
  please_select_ewallet: "Please select E-Wallet",
  please_select_payment: "Please select payment option",
  progress : "Progress",
  promotion_bonus: "Promotion Bonus",
  promotion_details: "Promotion Details",
  phone_no_reminder_recipient: "Please fill in recipient phone number",
  phone_recipient_same: "Recipient phone number cannot be the same as sender",
  promo_select: "Please Select Promotion",
  promo_none: "No Promotion",
  payment_option: "Payment Option",
  personal_info: "Personal Info",
  payment_info: "Payment Info (BANK)",
  payment_channel: "Payment Channel",
  processing: "Processing",
  payment_gateway: "Payment Gateway",

  ref_num_enter: "Please enter reference number",
  register: "Register",
  register_now: "Register Now",
  responsible_gambling: "Responsible Gambling",
  responsible_gaming: "Responsible Gaming",
  rebate: "Rebate",
  rejected: "Rejected",
  result: "RESULT",
  reward: "Reward",
  rewards: "Rewards",
  referral: "Referral",
  referral_link: "Referral Link: ",
  referral_desc: {
    one : "Refer & earn cashback up to ",
    two: "RM20 ",
    three: "for every new Referred Friend's non promo deposit",
  },
  referral_prefix: "Refer & earn cashback up to RM20 for every new Referred Friend's non promo deposit! Link: ",
  referral_code: "Referral Code",
  resend: "Resend",
  request_again: "Request OTP",
  reference_number: "Reference Number",
  reference_number_tooltips: "Please enter reference number",
  remarks: "Remarks",
  real_time: "Real Time",
  recipient_id: "Recipient ID",
  review: "Review | review",
  review_title: "Rate Your EPIC Game Journey",
  registered_player: "Total REGISTERED PLAYERS",
  royalty_level:{
    1: 'Bronze',
    2: 'Silver',
    3: 'Gold',
    4: 'Platinum',
    5: 'Diamond'
  },
  register_title: "Register Now & Get Free Angpow",
  register_popup:{
    title: "Welcome to Epicwin Philippines",
    content1: "Claim Freebet 24K",
    content2: "For new registered members, please contact whatsapp to claim the bonus",
    content3: "+628989977298",
    claim: "Claim Freebet"
  },

  save: "save",
  send: "Send",
  social_responsibility: "social responsibility",
  status: "Status",
  slotgames: "Slots",
  slot_play: "Play",
  slot_games: "Slot Games",
  slot_games_mobile: "Mobile Slot Games",
  signup: "Sign Up",
  signupform: {
    first_line: "I’m over 18 years of age and I accept these ",
    account_exist: "Already have an account?",
    verification_number: "Verification Number",
    problem_assist: "If you have problem receiving a code, kindly contact us via Live Chat.",
    subscription_confirm: "I want to know about offers & promotions via email, text or post.",
    account_success_first: "Your account has been ",
    account_success_second: "successfully created",
    deposit_now: "Deposit Now"
  },
  submit: "Submit",
  select_bonus: "Please Select Bonus / No Bonus",
  spin_again: "SPIN AGAIN",
  success: "Success",
  share: "Share",
  share_title: "Share to:",
  share_invite_code: "Share your invitation code",
  share_facebook:"Share to Facebook",
  share_to_friend: "Share to a Friend",
  share_referral_reward: "Get IDR 10.00 for both and your friend",
  select_deposit: "Please select deposit method",
  survey: {
    1: "Game Experience",
    2: "Withdrawal Speed",
    3: "Customer Service",
    4: "Game Design",
    5: "Refer Friend"
  },
  single_highest: "Single Bet with Highest Payout",
  signup_success: "Your account has been successfully created",
  skip: "skip",
  setting: "Setting",

  tac_tips: "If you have problem receiving OTP, please click the livechat button ",
  time: "Time",
  tutorials: "Tutorials",
  type: "Type",
  transfer: "Transfer",
  transfer_amount: "Transfer Amount",
  transaction_history: "Transaction History",
  transfer_history: "Transfer History",
  tnc: "T&C",
  tnc_full: "Terms and Conditions",
  tnc_accept_reminder: "Please tick the checkbox to agree with our terms and conditions",
  ticket_status: {
    "0": "Rejected",
    "1": "Approved"
  },
  tac_code : "OTP",
  tac_code_new: "New OTP has been sent to your phone number",
  topten_WITHDRAWAL: "withdrew",
  topten_DEPOSIT:"deposited",
  transaction: "Transaction",
  tutorial_deposit: "How to Deposit - In-App",
  tutorial_withdrawal: "How to Make Withdrawal - In App",
  tutorial_transfer: "How to Transfer - In App",
  tutorial_android: "How to Download - Android",
  tutorial_ios: "How to Download - IOS",
  transfer_fee: "Transfer Fee",
  transfer_fee_message: " RM0.20 per transaction",
  thankyou:{
    header: "Welcome to the Epic Family.",
    description: "Every member will receive a token of appreciation."
  },
  total_withdrawal: "MONTHLY NO. OF WITHDRAWAL",
  total_review: "MONTHLY NO. OF REVIEW",
  top_games: "TOP 10 POPULAR GAMES",
  topgames_period: "LAST 30 DAYS",

  username: "Username",
  uh_oh: "Uh-oh!",
  statement: "Statement",
  upload_file: "Upload File",
  upload_file_tooltips: "File size cannot exceed 1mb and must be in png, jpg or jpeg format",
  update: "update",
  update_email: "Update Email",
  update_email_success: "Email Update Successfully",
  unknown: "Unknown",

  verification_number: "SMS OTP",
  view_transaction_history: "view transaction history",
  view_transaction: "You can view transaction history up to 90 days.",
  verification_no_required: "OTP Required",
  phone_no_reminder: "Please enter last 4 digits of your phone number",
  videos: "Videos",
  video_link: "Video URL",

  welcome_to: "Welcome To",
  welcome_1: "The #1 Brand By Slots Maker.",
  welcome_2: "With all payments guaranteed",
  welcome_3: "Not just a brand, We're Slots Maker",
  withdrawal: "Withdrawal",
  withdraw_required: "Withdrawal amount required.",
  withdraw_greater_50: "Withdrawal amount must be greater than or equal to 50.",
  worth: "Worth",
  withdrawal_details: "Withdrawal Detail",
  withdrawal_details1: "The Numbers of Withdrawal: 5 times per day",
  withdrawal_details2: "Duration: 1min: RM10, 000",
  withdrawal_details3: "Duration: 3min: RM100, 000 & Above",
  withdrawal_speed: "WITHDRAWAL SPEED",
  withdrawal_epic: "EPIC WITHDRAWAL",
  withdrawal_topten: "TOP 10 WITHDRAWAL",
  winner_topten: "TOP 10 EPIC WINNERS",
  withdrawal_reminder: "Reminder: To avoid forfeiting your balance, please withdraw the full amount if you're taking any promotion",

  you_won: "You won the",
  you_have: "You have",
  withdraw_target_tips: "You need hit the target to withdraw",

  promo_display:{
    OTB: "Welcome Bonus",
    UB: "Daily Deposit Bonus",
    VIPB: "VIP Bonus",
    DB: "Daily Deposit Bonus"
  },

  rebate_toclaim: "Claimable Rebate",
  rebate_total: "Total Rebate",
  adjustment: "Adjustment",
  game_name: "Game Name",
  referee: "referee",
  platform: "platform",
  provider: "provider",
  turnover: "turnover",
  inbox: "Inbox",
  bank_profile: "bank profile",
  attachment: "attachment",
  completed: "completed",
  worldcup: "world cup",
  no_record: "No Record Found",
  earn_rebated: "Rebate Earned",
  turnover_amount: "Turnover Amount",
  acc_turnover: "Accumulate Turnover",
  earn_ticket : "Ticket Earned",
  total_downline: "Total Downline",
  submit_predict: "submit prediction",
  coming_soon: "coming soon",
  fill_predict: "*Please fill in your prediction",
  step_one: "step 1",
  home: "home",
  slot: "slot",
  slots: "slots",
  games: "games",
  livecasino: "livecasino",
  live: "live",
  casino: "casino",
  fishing: "fishing",
  sportsbook: "sportsbook",
  sports: "sports",
  book: "book",
  cockfight: "cockfight",
  real_time_trans: "Real Time Transaction",
  copy_referral: "Copy Referral Link",
  invite_friend: "Invite Friend!",
  bet_time: "bet time",
  bet_empty: "Your betlist is empty",
  result_empty: "No result",
  error_button: "BACK TO HOME PAGE",
  new_member: "new member",
  special: "special",
  daily: "daily",
  redeem: "redeem",
  bet_list: "Bet List",
  notice: "Notice",
  notice_welcome: "Welcome to EpicWin! Unlock 15% Bonus on Your First Daily Deposit! Play now and win big!",
  statement_daily: "Daily Statement",
  campaign: "campaign",
  worldcup_2022: "World cup 2022",
  turnover_downline: "Downline Turnover",
  daily_rebate: "Daily Game Rebate",
  redeem_ticket: "Redeem Ticket",
  back: "back",
  ticket: "Ticket",
  claimed_ticket: "Tickets claimed",
  ftd_message: "Congratulations, you have been rewarded with 30k, claim it now!",
  free_credit_message: "Free Credit is only available to play EpicWin games",
  deposit_amount: "Deposit Amount",
  self_rebate_rate:"self rebate rate",
  downline_rebate_rate: "downline rebate rate",
  more_info: "More Info",
  info: "Info",
  item: "Item",
  inboxTnc: {
    one: 'Free Credit IDR 24,000 will be given to members in "EPICWIN" Slots Game."',
    two: 'After achieving 10x Winover, the IDR30,000 will drop in Reward.',
    three: 'Upon redeem the free credits from “Reward”, the remaining win balance will be reset to zero.',
    four: 'Members need to deposit WITHOUT promotion and hit 1x Turnover requirement prior to withdraw.',
    five: 'Members deposit WITH promotion be based on the term and condition requirement of that particular promotion. ',
    six: 'The Free Credit amount will be FORFEITED if member deposit WITH promotion.',
    seven: 'General Terms & Conditions apply.'
  },
  referralTnc:{
    one: 'All members are able to join.',
    two: 'Your commission percentage level is determined based on the number of TURNOVER of your downline members EVERYDAY.',
    three: 'There is no maximum or minimum limit on how much you want to invite new members, the more your downline members the more benefits you will get.',
    four: 'Every new member is required to fill in your referral ID code or register via your referral link.',
    five: 'The referral link and code (ex: REF0000000001) can be seen in the "PROFILE" and "REFERRAL"',
    six: 'Turnover gained by using Free Credit is NOT entitle for rebate.',
    seven: "If members recommend themselves or do not follow the terms and conditions, Epicwin reserves the right not to distribute commissions.",
    eight: "Epicwin reserved all rights to terminate members' account if members violate the rules of referral program.",
    nine: 'For more info regarding the Referral bonus percentage, kindly refer to the table at the "i" button in the "REFERRAL" tab.'
  },
  footer_desc: "Epicwin uses cutting-edge methods to ensure the security of information we receive from you. All information we receive is transferred using hack-proof encryption technologies and, once stored on our servers, all data is safeguarded with the latest firewall technologies available. Our website and our gaming software utilize all available means to ensure the accuracy and privacy of data, and to protect the data from abuse or loss.",
  follow_us: "Follow Us",
  payment_method: "Payment Method",
  certification: "Certification",
  slot_desc:"Among all the game judi online, one of the most interested and iconic game nowadays is slots games. It is because slots games are the easiest game judi to understand especially game judi slot android. The higher bet you put meaning the greater gifts you can win and bring home with. Sometimes some situs judi slot will also provide freebet for you to enjoy their games. ",
  casino_desc: "Last time, live casino gambling game can only be done in certain places by visiting it directly. But now you can easily find some famous live casino online in Philippines such as Pragmatic, Microgaming and others with the help of situs judi online resmi like Epicwin.",
  sportsbook_desc: "Judi bola online has been familiar among the gambling players. Every year, football competitions are always held and must be used as betting event in situs judi bola. Nowadays, permainan judi bola online is already very famous not only in other countries but in Philippines also. Currently in Philippines, the sportbook terbaik is wbet.",
  username_guide: "Username must be 6-20 characters",
  trans_time: "Trans.Time",
  event: "Event",
  odds: "Odds",
  odd: "Odd",
  stake: "Stake",
  ref_no: "Ref No.",
  lost: "Lost",
  draw: "Draw",
  american_football: "American Football",
  soccer: "Soccer",
  basketball: "Basktetball",
  baseball: "Baseball",
  esports: "E-Sports",
  esports2: "E-Sports",
  tennis: "Tennis",
  even: "Even",
  over: "Over",
  under: "Under",
  slot_custom: "Slot",
  sb_custom: "Sportsbook",

  //country
  Argentina: "Argentina",
  Australia: "Australia",
  Belgium: "Belgium",
  Brazil: "Brazil",
  Cameroon: "Cameroon",
  Canada: "Canada",
  CostaRica: "Costa Rica",
  "Costa Rica": "Costa Rica",
  Croatia: "Croatia",
  Denmark: "Denmark",
  Ecuador: "Ecuador",
  England: "England",
  France: "France",
  Germany: "Germany",
  Ghana: "Ghana",
  Iran: "Iran",
  Japan: "Japan",
  Mexico: "Mexico",
  Morocco: "Morocco",
  Netherlands: "Netherlands",
  Poland: "Poland",
  Portugal: "Portugal",
  Qatar: "Qatar",
  SaudiArabia: "Saudi Arabia",
  "Saudi Arabia": "Saudi Arabia",
  Senegal: "Senegal",
  Serbia: "Serbia",
  SouthKorea: "South Korea",
  "South Korea": "South Korea",
  Spain: "Spain",
  Switzerland: "Switzerland",
  Tunisia: "Tunisia",
  Uruguay: "Uruguay",
  USA: "USA",
  Wales: "Wales"
};
